module.exports = __webpack_public_path__ + "static/media/trust.bca16aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trust.png
// module id = 840
// module chunks = 0